import {
  coreExtensionData,
  createExtension,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { TechDocsEntityContentEmptyState } from './TechDocsEntityContentEmptyState';

const techDocsEmptyStateElement = coreExtensionData.reactElement.optional();

const techDocsEntityContentEmptyState = createExtension({
  kind: 'empty-state',
  name: 'driveline-entity-content',
  attachTo: { id: 'entity-content:techdocs', input: 'emptyState' },
  output: [techDocsEmptyStateElement],
  factory: () => [
    coreExtensionData.reactElement(<TechDocsEntityContentEmptyState />),
  ],
});

export const techDocsEntityContentModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techDocsEntityContentEmptyState],
});
